import React, { useState } from 'react'

import { LocalDateTime } from '@js-joda/core'
import { GanttProps } from 'components/ComponentType'
import CalendarWrapper from 'components/basic/calendar-wrapper/CalendarWrapper'
import ProductTemplateTable from 'components/dashboard/product-template-table/ProductTemplateTable'
import useTimeState from 'hooks/dashboard/useTimeState'
import { TabPanel, TabView } from 'primereact/tabview'
import { T } from 'services/lang/LanguageService'
import GanttChartWrapper from './components/GanttChartWrapper'

const Gantt = (props: GanttProps) => {
  const [filter, setFilter] = useState<string | null>(null);

  const timeState = useTimeState({
    from: props.from ?? LocalDateTime.now().minusDays(7).toString(),
    to: props.to ?? LocalDateTime.now().toString(),
  });

  return (
    <div className="flex flex-column gap-3 p-3">
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2">
          <b className="pl-2">{T("word.from")}</b>
          <CalendarWrapper
            value={timeState.from}
            showTime
            onChange={date => timeState.setFrom(date)}
            dateFormat="yy-mm-dd"
          />
        </div>
        <div className="flex flex-column gap-2">
          <b className="pl-2">{T("word.to")}</b>
          <CalendarWrapper
            value={timeState.to}
            showTime
            onChange={date => timeState.setTo(date)}
            dateFormat="yy-mm-dd"
          />
        </div>
      </div>
      <TabView>
        <TabPanel header={T("word.chart")}>
          <GanttChartWrapper
            {...props}
            from={timeState.from?.toISOString()}
            to={timeState.to?.toISOString()}
            height={props.height}
            filter={filter}
          />
        </TabPanel>
        <TabPanel header={T("word.table")}>
          <ProductTemplateTable
            {...props}
            from={timeState.from?.toISOString()}
            to={timeState.to?.toISOString()}
            filter={filter}
            onFilterChange={val => setFilter(props.filter ? `${props.filter}${val && `;${val}`}` : val)}
          />
        </TabPanel>
      </TabView>
    </div>
  );
}

export default Gantt